"use strict";

var _toConsumableArray = require("/Users/davidx/projects/unishell/wallet/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function filterExcessSeparators(items) {
  return items.reduce(function (acc, item, index) {
    if (item.name === "separator" && index === 0) return acc;
    if (item.name === "separator" && index === items.length - 1) return acc;
    var prev = items[index - 1];
    if (prev && prev.name === "separator" && item.name === "separator") return acc;
    var next = items[index + 1];
    if (next && next.name === "separator" && item.name === "separator") return acc;
    return [].concat(_toConsumableArray(acc), [item]);
  }, []);
}

exports.default = filterExcessSeparators;